import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxTransformNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.3841 0.32008C12.1616 0.13468 11.8384 0.13468 11.6159 0.32008L8.4 2.99998H15.6L12.3841 0.32008Z"
        fill={color}
      />
      <path
        d="M11.6159 23.6799C11.8384 23.8653 12.1616 23.8653 12.3841 23.6799L15.6 21H8.4L11.6159 23.6799Z"
        fill={color}
      />
      <path
        d="M0.424298 11.5757C0.189998 11.81 0.189998 12.1899 0.424298 12.4242L3 14.9999V8.99988L0.424298 11.5757Z"
        fill={color}
      />
      <path
        d="M23.6799 12.3841C23.8653 12.1616 23.8653 11.8384 23.6799 11.6159L21 8.40002V15.6L23.6799 12.3841Z"
        fill={color}
      />
      <path d="M6 10.2H2.4V13.8H6V10.2Z" fill={color} />
      <path d="M13.8 2.40002H10.2V6.00002H13.8V2.40002Z" fill={color} />
      <path d="M21.6 10.2H18V13.8H21.6V10.2Z" fill={color} />
      <path d="M13.8 18H10.2V21.6H13.8V18Z" fill={color} />
      <path
        d="M13.6769 11.5507C13.139 9.54309 13.2424 7.36359 13.2424 7.36359C13.2424 7.36359 12.2422 9.30279 10.7725 10.7725C9.3028 12.2422 7.3636 13.2424 7.3636 13.2424C7.3636 13.2424 9.5431 13.139 11.5507 13.6769C13.5583 14.2149 15.3941 15.3942 15.3941 15.3942C15.3941 15.3942 14.2149 13.5583 13.6769 11.5507Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxTransformNsk.displayName = 'ToolboxTransformNsk';
